import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

export default {
    'api1': {
        onLoad: true,
        action: (lang, match, query) => {
            let body = {
                page: query.page,
                entries: query.entries,
                filter: query.filter,
                sortType: query.sortType ? query.sortType : -1,
                sortField: query.sortField ? query.sortField : '_id',
                type: query.type ? query.type : 'all'
            };

            // VD-725: omit the field entirely when a filter is not selected, the
            // backend treats a missing field as "all" - and it wants a real
            // boolean, not the "true"/"false" string the URL query carries.
            if (query.externalApiAuth === 'basic' || query.externalApiAuth === 'apiKey') {
                body.externalApiAuth = query.externalApiAuth;
            } else {
                // this page only ever lists clients that use the external API
                body.useExternalApi = true;
            }

            if (query.externalApiHeavy === 'true' || query.externalApiHeavy === 'false') {
                body.externalApiHeavy = query.externalApiHeavy === 'true';
            }

            return fetch(API_ENDPOINT + '/data/clients', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },

                body: JSON.stringify(body)
            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300)
                    return {
                        items: result.items,
                        total: result.total,
                        listError: null,
                    }

                return {
                    items: [],
                    total: 0,
                    listError: result && result.error ? result.error : null,
                }
            })
        }
    },
    /* --- VD-725 external client API keys ------------------------------- */

    'apiKeys': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/clients/' + data.clientId + '/api-keys', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'apiKeyNew': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/clients/' + data.clientId + '/api-keys/new', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data.data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'apiKey': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/api-keys/' + data.id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'apiKeyUpdate': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/api-keys/' + data.id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data.data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'apiKeyRotate': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/api-keys/rotate/' + data.id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data.data ? data.data : {})
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },

    'apiKeyRevoke': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/api-keys/' + data.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    }

}
